/**
 * Формирует URL для доступа к файлу через backend proxy
 * Все файлы загружаются из S3 через авторизованный endpoint
 */
export const getFileUrl = (file: { id?: number | string; uri?: string; path?: string } | undefined | null): string => {
	if (!file) {
		return '';
	}

	// Если есть id - используем backend proxy
	if (file.id) {
		return `/api/file/download/${file.id}`;
	}

	// Fallback если id нет (для старых данных во время миграции)
	console.warn('File without id:', file);
	return '';
};
